import { useMemo } from "react";
import { Container, Button, Paper, Box, TableContainer, Table, TableHead, TextField, TableBody, TableRow, TableCell, Alert, Typography } from "@mui/material";
import { ArrowBack, PictureAsPdf, Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { filterByDate, clearResult } from "../../features/students/studentsSlice";
import { createFile } from "../../features/download/downloadSlice";
import { ChipYears, CustomTable, EventsChart } from "../Tools";
import Forms from "./Forms";

const checkIsRoot = type => type === 'root';

export default function Student(){
    const { type } = useSelector(state => state.auth)
    const { isSending } = useSelector(state => state.progress);
    const { students, student: { backup, total, hours, dataChart, years } } = useSelector(state => state.students);
    const isRoot = useMemo(() => checkIsRoot(type), [type])
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const handleChange = event => dispatch(filterByDate(event.target.value))
    const headers = ['Fecha', 'Tipo', 'Evento', 'Horas', 'Área'];

    const studentHeaders = [
        { name: 'Código', ref: 'codigo' }, 
        { name: 'Nombre', ref: 'nombre' }, 
        { name: 'Estatus', ref: 'estatus' }, 
        { name: 'Sexo', ref: 'genero' },
        { name: 'Etnia', ref: 'etnia' },
        { name: 'Calendario', ref: 'calendario' },
        { name: 'Sede', ref: 'sede' }
    ];
    
    const goBack = () => {
        dispatch(clearResult())
        navigate('/estudiantes')
    }
    let lenBackUp = backup.length;
    return(
        <Container component={Paper} sx={{ p: '2em', mb: '2em' }}>
            <Typography variant="h5" align="center" gutterBottom>Datos del Estudiante</Typography>
            <Box display={'flex'} sx={{ justifyContent: 'space-between', mb: '1em', mt: '1em' }}>
                <Alert severity="success">Eventos: <b>{total}</b></Alert>
                <Alert severity="info">Horas: <b>{hours}</b></Alert>
            </Box>
            <CustomTable data={students} headers={studentHeaders} edit={true} showFound={false} />
            <Forms isRoot={isRoot} /><br />
            <Button onClick={() => goBack()} startIcon={<ArrowBack />} variant="outlined">Regresar</Button>
            <br />
            { total ? (
                <>
                    <ChipYears years={years} />
                    <EventsChart data={dataChart} />
                    <TableContainer sx={{ mt: '1em' }}>
                        <Box display={'flex'} sx={{ justifyContent: 'space-between', mb: '1em', mt: '1em' }}>
                            <TextField name="filter" label="Filtrar fecha (YYYY-MM)" inputProps={{ maxLength: 7 }} onChange={handleChange}/>
                            <LoadingButton 
                                loading={isSending}
                                onClick={() => createFile('report', { id: students[0].id }, dispatch)}
                                color="success"
                                startIcon={<Download />} 
                                endIcon={<PictureAsPdf />} 
                                variant="outlined"
                                title="Descargar PDF">
                                    REPORTE
                            </LoadingButton>
                        </Box>
                        <Alert severity="info">Mostrados: <b>{lenBackUp}</b></Alert>
                        { lenBackUp ? (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        { headers.map((h, i) => <TableCell key={i}>{h}</TableCell>) }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { backup.map(({ fecha, tipo, nombre, horas, carrera }, i) => (
                                        <TableRow key={i}>
                                            <TableCell>{fecha}</TableCell>
                                            <TableCell>{tipo}</TableCell>
                                            <TableCell>{nombre}</TableCell>
                                            <TableCell align="center">{horas}</TableCell>
                                            <TableCell>{carrera}</TableCell>
                                        </TableRow>
                                    )) }
                                </TableBody>
                            </Table>
                        ) : <Alert severity="warning">No se econtraron eventos</Alert> }
                    </TableContainer>
                </>
            ) : <Alert sx={{ mt: '1em' }} severity="warning">No se econtraron eventos</Alert> }
        </Container>
    )
}